/* ─────────────────────────────────────────────────────────────────────────
   Collection behaviours.
   - Filter forms auto-submit on change (forms with [data-auto-submit])
   - Sort selects ([data-sort-select]) rewrite sort_by on the current URL,
     preserving every active filter param
   - Empty fields are disabled before submit so URLs stay clean
   The mobile drawer itself uses the shared [data-drawer] pattern in
   global.js — no drawer code needed here.
   ──────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  /* Disable empty text/number/hidden fields so they don't serialize. */
  function pruneEmpty(form) {
    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name) return;
      var type = field.type;
      if ((type === 'text' || type === 'number' || type === 'hidden') && field.value === '') {
        field.disabled = true;
      }
    });
  }

  document.addEventListener('change', function (event) {
    var el = event.target;

    /* Sort: keep the rest of the query string (filters) intact. */
    if (el.matches('[data-sort-select]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', el.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
      return;
    }

    /* Filters: auto-submit the owning form. */
    var form = el.form;
    if (form && form.hasAttribute('data-auto-submit')) {
      pruneEmpty(form);
      form.submit();
    }
  });

  /* The mobile drawer form submits via its "Show N candles" button. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches && form.matches('[data-filter-form]')) {
      pruneEmpty(form);
    }
  });
})();
